<template>
  <div>
    <wc-data-box
      :title='$store.state.icons.modules.budgetLines.title'
      :titleIcon='$store.state.icons.modules.budgetLines.icon'
      :titleIconColor='$store.state.icons.modules.budgetLines.color'
      showAdd
      showSearch
      @add='add'
      v-model='search'
      :loading='loading'
    >
      <v-data-table
        :items='lines'
        :headers='headers'
        :items-per-page='-1'
        :search='search'
        dense
        hide-default-footer
        multi-sort
        @click:row='edit'
      >
        <template v-slot:item.has_gst='{ item }'>
          {{ item.has_gst | trueFalse }}
        </template>
        <template v-slot:item.amount='{ item }'>
          {{ item.amount | dec }}
        </template>
      </v-data-table>
    </wc-data-box>
    <wc-dialog
      :showDialog='showDialog'
      :title='$store.state.icons.modules.budgetLines.title'
      :icon='$store.state.icons.modules.budgetLines.icon'
      width='400'
      @save='save'
      @cancel='showDialog = false'
      :disableButtons='!isFormValid'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-autocomplete
          :items='divisions'
          v-model='budgetLineCopy.division'
          label='Division'
          item-text='division'
          item-value='id'
          clearable
        ></v-autocomplete>
        <v-autocomplete
          :items='main_categories'
          v-model='budgetLineCopy.main_category'
          label='Main Category'
          item-text='description'
          item-value='id'
          @change='updateHasGST'
          :rules='[rules.required]'
        ></v-autocomplete>
        <v-autocomplete
          :items='sub_categories'
          v-model='budgetLineCopy.sub_category'
          label='Sub Category'
          item-text='description'
          item-value='id'
        ></v-autocomplete>
        <v-autocomplete
          :items='sub_sub_categories'
          v-model='budgetLineCopy.sub_sub_category'
          label='Sub SUB Category'
          item-text='description'
          item-value='id'
        ></v-autocomplete>
        <v-checkbox
          v-model='budgetLineCopy.has_gst'
          label='GST included?'
          hint='Initially set by main category, but can be overridden'
          persistent-hint
        ></v-checkbox>
        <v-text-field
          class='mt-1'
          append-icon='mdi-currency-usd'
          reverse
          v-model='budgetLineCopy.amount'
          placeholder='Budget amount'
          :rules='[rules.decimalOrEmpty]'
        ></v-text-field>
        <v-textarea
          class='mt-1'
          v-model='budgetLineCopy.notes'
          label='Notes'
          outlined
        ></v-textarea>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'budget-lines',
  mixins: [formRules],
  data: () => ({
    showDialog: false,
    isFormValid: false,
    search: '',
    budgetLineCopy: {
      division: null,
      has_gst: false
    },
    headers: [
      { text: 'Division', value: 'division_obj.division' },
      { text: 'Main category', value: 'main_category_obj.description' },
      { text: 'Sub category', value: 'sub_category_obj.description' },
      { text: 'Sub SUB category', value: 'sub_sub_category_obj.description' },
      { text: 'GST?', value: 'has_gst', align: 'center' },
      { text: 'Notes', value: 'notes' },
      { text: 'Amount', value: 'amount', align: 'end' }
    ]
  }),
  props: {
    budget: {
      required: true
    },
    lines: {
      required: true
    },
    categories: {
      required: true
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    } 
  },
  computed: {
    divisions () {
      return (_.sortBy(this.$store.state.misc.divisions, 'division'))
    },
    main_categories () {
      return this.categories.filter(c => c.is_main_category == true)
    },
    sub_categories () {
      return this.categories.filter(c => c.is_sub_category == true)
    },
    sub_sub_categories () {
      return this.categories.filter(c => c.is_sub_sub_category == true)
    }
  },
  methods: {
    resetCopy () {
      this.budgetLineCopy.has_gst = false
      this.budgetLineCopy.amount = null
      this.budgetLineCopy.notes = ''
      this.budgetLineCopy.budget = this.budget.id
      this.budgetLineCopy.main_category = null
      this.budgetLineCopy.sub_category = null
      this.budgetLineCopy.sub_sub_category = null
      this.budgetLineCopy.division = null
    },
    add () {
      this.resetCopy()
      this.showDialog = true
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
    },
    edit (item) {
      this.budgetLineCopy = _.cloneDeep(item)
      this.showDialog = true
    },
    save () {
      this.$emit('saveLine', this.budgetLineCopy)
      this.showDialog = false
    },
    updateHasGST () {
      let cat = this.categories.find(c => c.id === this.budgetLineCopy.main_category)
      this.budgetLineCopy.has_gst = cat.has_gst
    },
    clearDivision () {
      this.budgetLineCopy.division = null
    }
  }
}
</script>
